import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    title: 'TOMO 1 — SISTEMAS FORESTALES',
    icon: '🌱',
    items: ['Tipos de sistemas forestales', 'Organización productiva', 'Manejo forestal', 'Producción y evaluación', 'Estructura del sistema'],
    highlight: 'Para enseñar la base de la forestación'
  }, {
    title: 'TOMO 2 — VIVEROS FORESTALES',
    icon: '🌿',
    items: ['Producción de plantines', 'Sustratos', 'Manejo del vivero', 'Cuidados y crecimiento', 'Organización del espacio'],
    highlight: 'Para llevar la teoría a lo práctico'
  }, {
    title: 'TOMO 3 — PLANTACIÓN Y MANEJO',
    icon: '🌲',
    items: ['Técnicas de plantación', 'Preparación del suelo', 'Manejo del cultivo', 'Control de crecimiento', 'Mantenimiento'],
    highlight: 'Para enseñar procesos reales'
  }, {
    title: 'TOMO 4 — ESPECIES FORESTALES',
    icon: '🌳',
    items: ['Clasificación de especies', 'Características productivas', 'Adaptación al entorno', 'Selección forestal', 'Uso de especies'],
    highlight: 'Para enseñar decisiones reales'
  }, {
    title: 'TOMO 5 — APROVECHAMIENTO DE MADERA',
    icon: '🪵',
    items: ['Extracción', 'Procesos productivos', 'Uso de madera', 'Comercialización', 'Cadena productiva'],
    highlight: 'Para enseñar el valor real del recurso'
  }, {
    title: 'TOMO 6 — SUSTENTABILIDAD FORESTAL',
    icon: '♻️',
    items: ['Manejo sustentable', 'Impacto ambiental', 'Conservación', 'Producción responsable', 'Normativas básicas'],
    highlight: 'Para enseñar con enfoque actual'
  }];
  return <section className="bg-[#121E19] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-102">
      <div className="max-w-2xl mx-auto" data-id="element-103">
        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-3 uppercase tracking-tight" data-id="element-104">
          📖 QUÉ RECIBÍS
        </h2>

        <div className="space-y-1.5 mb-4" data-id="element-105">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#0B1F17] border border-[#1F3D2B] rounded-lg overflow-hidden" data-id="element-106">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-2.5 text-left hover:bg-[#102A1F] transition-colors" data-id="element-107">
                  <span className="font-black text-[#74C69D] text-xs md:text-sm flex items-center gap-2 uppercase" data-id="element-108">
                    <span className="text-base" data-id="element-109">{tomo.icon}</span> {tomo.title}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-110">
                    <ChevronDown className="w-4 h-4 text-[#D4A843]" data-id="element-111" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-112">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-113">
                      <div className="px-3 pb-3 border-t border-[#1F3D2B] bg-[#0B1F17]" data-id="element-114">
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 mt-2 mb-2" data-id="element-115">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-[#BFC9C5] font-bold text-[10px] md:text-xs" data-id="element-116">
                              <Check className="w-3.5 h-3.5 text-[#74C69D] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-117" />
                              <span data-id="element-118">{item}</span>
                            </li>)}
                        </ul>
                        <div className="bg-[#102A1F] border border-[#D4A843]/30 rounded p-1.5 text-center mt-2" data-id="element-119">
                          <p className="text-[#D4A843] font-black text-[10px] md:text-xs" data-id="element-120">
                            👉 {tomo.highlight}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-[#102A1F] border border-[#D4A843] rounded-xl p-3 shadow-lg" data-id="element-121">
          <p className="text-sm md:text-base font-black text-white mb-1 uppercase" data-id="element-122">
            🔥 Todo paso a paso, listo para aplicar.
          </p>
          <p className="text-xs font-black text-[#74C69D]" data-id="element-123">
            👉 Entrás a cada clase con todo resuelto.
          </p>
        </div>
      </div>
    </section>;
}